import { QueryFunctionContext } from '@tanstack/react-query'
import { DELETE, GET, POST, PUT } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import customReportEndpoints from '../api/customReportEndpoints'
import customReportQueryKeys from '../queries/customReportQueryKeys'
import { CustomReportSectionsType } from '../../../redux/context/customReports/typesSection'
import { formatAsDate, endOfMonth } from '../../../config/dayjsConfig'

export const fetchCustomReportSectionQuery = ({
  queryKey: [{ companyId, reportId, sectionId, date, language, args }],
  signal
}: QueryFunctionContext<ReturnType<(typeof customReportQueryKeys)['section']>>) => {
  return backendRequest<CustomReportSectionsType>({
    method: GET,
    url: customReportEndpoints.section(companyId, reportId, sectionId),
    params: {
      lng: language,
      date: formatAsDate(date),
      ...(args && args.length > 0 && { args: JSON.stringify(args) })
    },
    signal
  })
}

export const createCustomReportSection = (
  companyId: string,
  reportId: number,
  section: CustomReportSectionsType,
  date?: string
) => {
  return backendRequest<CustomReportSectionsType>({
    method: POST,
    url: customReportEndpoints.sectionList(companyId, reportId),
    data: section,
    params: {
      date: section.type === 'text' ? endOfMonth(date) : undefined
    }
  })
}

export const updateCustomReportSection = (
  companyId: string,
  reportId: number,
  sectionId: number,
  section: CustomReportSectionsType,
  date?: string
) => {
  return backendRequest<CustomReportSectionsType>({
    method: PUT,
    url: customReportEndpoints.section(companyId, reportId, sectionId),
    data: section,
    params: {
      date: section.type === 'text' ? endOfMonth(date) : undefined
    }
  })
}

export const deleteCustomReportSectionApi = (companyId: string, reportId: number, sectionId: number) => {
  return backendRequest<void>({
    method: DELETE,
    url: customReportEndpoints.section(companyId, reportId, sectionId)
  })
}

export const deleteCustomReportVariable = (
  companyId: string,
  reportId: number,
  sectionId: number,
  variableId: number
) => {
  return backendRequest<void>({
    method: DELETE,
    url: customReportEndpoints.variable(companyId, reportId, sectionId, variableId)
  })
}
